/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmployeeAccessTypeDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { LanguageDto } from '../models';
// @ts-ignore
import type { PmcDistributionDto } from '../models';
/**
 * TeamPmcDistributionApi - axios parameter creator
 * @export
 */
export const TeamPmcDistributionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Rozklad ocen PMC w obszarze plus srednia. Ocena finalna PMC jest wartoscia ze skali 1-5 (1 = znacznie powyzej oczekiwanych zachowan, 5 = znacznie ponizej), wiec kazdy stopien skali ma wlasny slupek. Suma slupkow zawsze rowna sie liczbie osob z odczytana ocena. 
         * @summary PMC score distribution across the caller\'s area (JAIN-500)
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readPmcDistribution: async (accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/team/development/pmc-distribution`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accessType !== undefined) {
                localVarQueryParameter['accessType'] = accessType;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamPmcDistributionApi - functional programming interface
 * @export
 */
export const TeamPmcDistributionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamPmcDistributionApiAxiosParamCreator(configuration)
    return {
        /**
         * Rozklad ocen PMC w obszarze plus srednia. Ocena finalna PMC jest wartoscia ze skali 1-5 (1 = znacznie powyzej oczekiwanych zachowan, 5 = znacznie ponizej), wiec kazdy stopien skali ma wlasny slupek. Suma slupkow zawsze rowna sie liczbie osob z odczytana ocena. 
         * @summary PMC score distribution across the caller\'s area (JAIN-500)
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readPmcDistribution(accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PmcDistributionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readPmcDistribution(accessType, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamPmcDistributionApi.readPmcDistribution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamPmcDistributionApi - factory interface
 * @export
 */
export const TeamPmcDistributionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamPmcDistributionApiFp(configuration)
    return {
        /**
         * Rozklad ocen PMC w obszarze plus srednia. Ocena finalna PMC jest wartoscia ze skali 1-5 (1 = znacznie powyzej oczekiwanych zachowan, 5 = znacznie ponizej), wiec kazdy stopien skali ma wlasny slupek. Suma slupkow zawsze rowna sie liczbie osob z odczytana ocena. 
         * @summary PMC score distribution across the caller\'s area (JAIN-500)
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readPmcDistribution(accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<PmcDistributionDto> {
            return localVarFp.readPmcDistribution(accessType, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamPmcDistributionApi - interface
 * @export
 * @interface TeamPmcDistributionApi
 */
export interface TeamPmcDistributionApiInterface {
    /**
     * Rozklad ocen PMC w obszarze plus srednia. Ocena finalna PMC jest wartoscia ze skali 1-5 (1 = znacznie powyzej oczekiwanych zachowan, 5 = znacznie ponizej), wiec kazdy stopien skali ma wlasny slupek. Suma slupkow zawsze rowna sie liczbie osob z odczytana ocena. 
     * @summary PMC score distribution across the caller\'s area (JAIN-500)
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamPmcDistributionApiInterface
     */
    readPmcDistribution(accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<PmcDistributionDto>;

}

/**
 * TeamPmcDistributionApi - object-oriented interface
 * @export
 * @class TeamPmcDistributionApi
 * @extends {BaseAPI}
 */
export class TeamPmcDistributionApi extends BaseAPI implements TeamPmcDistributionApiInterface {
    /**
     * Rozklad ocen PMC w obszarze plus srednia. Ocena finalna PMC jest wartoscia ze skali 1-5 (1 = znacznie powyzej oczekiwanych zachowan, 5 = znacznie ponizej), wiec kazdy stopien skali ma wlasny slupek. Suma slupkow zawsze rowna sie liczbie osob z odczytana ocena. 
     * @summary PMC score distribution across the caller\'s area (JAIN-500)
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamPmcDistributionApi
     */
    public readPmcDistribution(accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return TeamPmcDistributionApiFp(this.configuration).readPmcDistribution(accessType, lang, options).then((request) => request(this.axios, this.basePath));
    }
}

